export enum WxUserActionTypes {
  API_RESPONSE_SUCCESS = '@@wxUsers/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@wxUsers/API_RESPONSE_ERROR',

  LIST_WXUSERS = '@@wxUsers/LIST_WXUSERS',

  RESET = '@@wxUsers/RESET',
}